module.exports = __webpack_public_path__ + "static/media/006a_thumb.0ce2bdc4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/commission/images/006a_thumb.jpg
// module id = 176
// module chunks = 0